<template>
  <div class="faqs-question">
    <div class="faqs-title mx-auto">
      <h2 class="mb-2 font-weight-bold">
        FAQs
      </h2>
    </div>
    <div class="content-question mx-auto text-left">
      <template v-for="(data, index) in questions">
        <div
          :key="data.id"
          class="d-flex justify-content-between align-items-center item"
        >
          <u
            class="mb-0"
            v-b-toggle="data.id"
            @click="active(index)"
            v-html="data.question"
          ></u>
          <span @click="active(index)">
            <img
              v-b-toggle="data.id"
              :src="require('@/assets/images/icons/ic_arrow_down.svg')"
            />
          </span>
        </div>
        <b-collapse :id="data.id" :key="'answer-' + index">
          <p class="quick-answer font-weight-thin" v-html="createSuccessFeeLink(data.answer)"></p>
        </b-collapse>
      </template>
      <div class="content-question-link mt-2">
        <p class="content-question-text text-center">
          For more details, visit our
          <u><a class="text-dark" href="https://www.autoflip.com.au/faqs" target="_blank">FAQ</a></u> page.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "FAQs",
  data() {
    return {
      questions: [
        {
          id: 'question-1',
          question: "How long does it take to sell my car through AutoFlip?",
          answer: "AutoFlip typically finds a competitive offer for your car within 24 hours of listing.",
          isActive: false
        },
        {
          id: 'question-2',
          question: "Who will buy my car through AutoFlip?",
          answer: "Your car will be sold to a trusted network of licensed dealers across Australia, avoiding dodgy tyre kickers and time wasters.",
          isActive: false
        },
        {
          id: 'question-3',
          question: "What are AutoFlip's fees?",
          answer: `AutoFlip charges a success fee when you accept an offer from a successful buyer - NO DEAL, NO FEE.`,
          isActive: false
        },
        {
          id: 'question-4',
          question: "Can I advertise my car elsewhere while using AutoFlip?",
          answer: "To increase your chance of a successful sale, any other ads must be paused while your car is actively listed on AutoFlip.",
          isActive: false
        }
      ],
      isMobile: true,
    };
  },
  methods: {
    active(num) {
      this.questions[num].isActive = !this.questions[num].isActive;
    },
    createSuccessFeeLink(answer) {
      const createLink = (text, url) => 
        `<a style="color: #000000; text-decoration: underline" href="${url}" target="_blank">${text}</a>`;

      let result = answer;

      const replacements = [
        { placeholder: "success fee", url: `${this.policyDocumentsLinks.successFee}` },
      ];

      replacements.forEach(({ placeholder, url }) => {
        result = result.replace(placeholder, createLink(placeholder, url));
      });

      return result;
    }
  },
  computed: {
    ...mapState({
      policyDocumentsLinks: (state) => state.commonVariables.policyDocumentsLinks,
    }),
    mobileMediaQuery: function() {
      return window.matchMedia("(min-width: 1200px)");
    },
  },
  mounted() {
    this.mobileMediaQuery.addListener((e) => {
      if (e.matches) {
        this.isMobile = false;
      } else {
        this.isMobile = true;
      }
    });

    this.isMobile = !this.mobileMediaQuery.matches;
  },
};
</script>

<style lang="scss">
.faqs-question {
  background-color: #f9fafb;
  margin-bottom: 20px;

  .faqs-title {
    line-height: 28px;
    padding-top: 27px;
    color: #1F8252
  }

  .content-question {
    max-width: 414px;
    padding: 0 24px 10px;

    .item {
      min-height: 65px;

      u {
        color: #000000;
      }

      p {
        color: #000000;
        font-size: 14px;
        font-weight: bold;
        line-height: 20px;
      }

      span {
        .not-collapsed {
          transform: rotate(180deg);
          transition: ease-in-out 0.3s;
        }
        .collapsed {
          transition: ease-in-out 0.3s;
        }
      }

      img {
        width: 14px;
        height: 8px;
        cursor: pointer;
        margin-left: 5px;
        // transform: rotate(90deg);
      }
    }

    hr {
      border-color: #404040;
      margin-top: 0;
      margin-bottom: 0;
    }

    .quick-answer {
      font-size: 16px;
    }

    .content-question-link {
      color: #000000;
    }
  }
}

@media screen and(min-width: 768px) {
  .faqs-question {
    margin-bottom: 0 !important;

    .faqs-title {
      font-size: 26px !important;
      line-height: 34px !important;
      padding-top: 30px !important;
    }

    .content-question {
      max-width: 1081px !important;

      .item p {
        line-height: 20px !important;
        font-size: inherit !important;
      }

      .quick-answer {
        font-size: inherit !important;
        width: 90% !important;
      }

      span {
        &:hover {
          transform: translateY(-1.5px);
          transition: ease-in-out 0.2s;
        }
      }
    }
  }
}
</style>